import { Component } from '@theme/component';

/**
 * In-drawer shipping & returns slideover panel (not a nested modal dialog).
 *
 * @typedef {object} Refs
 * @property {HTMLElement} panel – Slideover panel root.
 * @property {HTMLButtonElement} closeButton – Close control.
 *
 * @extends {Component<Refs>}
 */
class WfCartShippingSlideover extends Component {
  requiredRefs = ['panel', 'closeButton'];

  /** @type {(event: KeyboardEvent) => void} */
  #boundKeyDown = this.#handleKeyDown.bind(this);

  connectedCallback() {
    super.connectedCallback();
    this.setAttribute('aria-hidden', 'true');
    this.refs.panel?.setAttribute('inert', '');
  }

  open() {
    this.classList.add('is-open');
    this.setAttribute('aria-hidden', 'false');
    this.refs.panel?.removeAttribute('inert');
    document.addEventListener('keydown', this.#boundKeyDown);
    this.refs.closeButton?.focus();
  }

  close() {
    this.classList.remove('is-open');
    this.setAttribute('aria-hidden', 'true');
    this.refs.panel?.setAttribute('inert', '');
    document.removeEventListener('keydown', this.#boundKeyDown);
  }

  /**
   * @param {KeyboardEvent} event
   */
  #handleKeyDown(event) {
    if (event.key !== 'Escape') return;

    event.preventDefault();
    event.stopPropagation();
    this.close();
  }
}

if (!customElements.get('wf-cart-shipping-slideover')) {
  customElements.define('wf-cart-shipping-slideover', WfCartShippingSlideover);
}
